var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-avatar__outer",class:( _obj = {}, _obj['clickable'] = !!_vm.clickable, _obj['active'] = _vm.isActive, _obj )},[_c('div',{staticClass:"v-avatar__wrapper",class:( _obj$1 = {}, _obj$1['use-initials'] = _vm.useInitials, _obj$1 ),style:({
      width: _vm.width,
      height: _vm.height,
      maxWidth: _vm.width,
      backgroundColor: _vm._bgColor,
      fontSize: _vm.useInitials ? _vm.fontSize : 'inherit',
    }),on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.useInitials)?_c('span',[_vm._v(" "+_vm._s(_vm.getLogoLetters())+" ")]):_c('img',{attrs:{"src":_vm.image,"alt":"avatar"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }